import React from "react";
import { boldIcon, italicIcon, underlineIcon, bulletIcon, numberIcon, formatIcon } from "./icons";
import "./quill.css";
import "./style.css";

var toolbarOptions = ['bold', 'italic', 'underline', 'divider', { 'list': 'ordered' }, { 'list': 'bullet' }, 'divider', 'clean'];
var focusLock = false;
var hylyEditor;
var toolbar;

export default React.memo(({ value, onChange, onBlur, onFocus, setToolbarVisible }) => {

  React.useEffect(() => {

    var icons = window.Quill.import('ui/icons');
    icons['bold'] = boldIcon;
    icons['italic'] = italicIcon;
    icons['underline'] = underlineIcon;
    icons['list']['bullet'] = bulletIcon;
    icons['list']['ordered'] = numberIcon;
    icons['clean'] = formatIcon;


    hylyEditor = new window.Quill('#editor', {
      theme: 'snow',
      modules: {
        toolbar: toolbarOptions,
      }
    });

    //document.getElementById("editor").style.borderTop = "1px solid #cccccc";
    document.getElementById("editor").style.border = "none";
    if (setToolbarVisible) {
      focusLock = true;
      let toolbar = document.getElementsByClassName("ql-toolbar")[0];
      if (toolbar) {
        toolbar.style.border = "none";
        toolbar.style.borderTop = "1px solid #dadada";
      }
    } else {
      toggleToolbar();
    }
    addListeners();
    addTooltips();
    if (typeof onChange === "function") onChange(`<div id="editor">${value}</div>`);
    return removeListener;

  }, [1]);

  const toggleToolbar = (show) => {
    if (setToolbarVisible) {
      return
    }
    let toolbar = document.getElementsByClassName("ql-toolbar")[0];
    if (toolbar) {
      toolbar.style.display = show ? "block" : "none";
      toolbar.style.borderTop = "none";
    }
  }

  const addTooltips = () => {
    let toolbar = document.getElementsByClassName('ql-toolbar');
    let tooltips = ["Bold", "Italic", "Underline", false, "Numbered List", "Bulleted List", false, "Remove Formating"]
    if (toolbar[0]) {
      for (let i = 0; i < toolbar[0].children[0].children.length; i++) {
        let tltp = document.createElement("span");
        tltp.innerHTML = tooltips[i];
        tltp.className = "editor-tooltip"
        toolbar[0].children[0].children[i].appendChild(tltp);
      }
    }
  }

  const addListeners = () => {

    toolbar = document.getElementsByClassName("ql-toolbar")[0]
    toolbar.addEventListener('focusin', e => {
      focusLock = true;
    });
    toolbar.addEventListener('focusout', e => {
      setTimeout(() => {
        focusLock = false;
      }, 100)

    });

    document.getElementById("editor").firstChild.onblur = () => {
      setTimeout(() => {
        if (!focusLock) {
          toggleToolbar()
        }
      }, 100)


      var html = hylyEditor.root.innerHTML;
      if (typeof onBlur === "function") onBlur(html);
      if (typeof onChange === "function") onChange(`${html}`);
    }

    document.getElementById("editor").firstChild.onfocus = () => {
      toggleToolbar(true)
      var html = hylyEditor.root.innerHTML;
      if (typeof onFocus === "function") onFocus(html)
    }
  }

  const removeListener = () => {
    toolbar.removeEventListener('focusin', e => { });
    toolbar.removeEventListener('focusout', e => { });
  }


  return (
    <div style={{ display: "flex", flexDirection: "column-reverse", position: "relative" }}>
      <div id="editor">
        <p dangerouslySetInnerHTML={{ __html: value }}></p>
      </div>
    </div>

  )

})